import { queryOptions } from '@tanstack/react-query';
import { reviewApi } from './review-api';

export const reviewKeys = {
  all: ['review'] as const,
  /** The merchant's reviews across every branch. */
  list: () => [...reviewKeys.all, 'list'] as const,
};

export const reviewQueries = {
  /**
   * Every review the merchant has received.
   *
   * ONE page, not an infinite query: the endpoint has no server-side sort or
   * rating filter, so both of the screen's pills operate over whatever is
   * loaded (see `lib/filter-reviews.ts`). Paging would make those filters
   * progressively less truthful as the merchant scrolled — "С высокой оценкой"
   * would silently mean "…among the first N" — so the screen reads one
   * generous page and the pills act on a stable set.
   */
  list: () =>
    queryOptions({
      queryKey: reviewKeys.list(),
      queryFn: ({ signal }) => reviewApi.list({ signal }),
    }),
};
